import { DollarSign, TrendingUp } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { fmtBRL, fmtInt } from "@/lib/format";

export default function RankingReceita({ metrics = [] }) {
  const sorted = [...metrics].sort((a, b) => b.receita - a.receita);
  const max = sorted[0]?.receita || 1;

  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid="ranking-receita">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <DollarSign className="w-4 h-4 text-primary" />
          <h3 className="font-heading font-semibold text-lg">Ranking por receita</h3>
        </div>
        <Badge variant="outline">Ponderado pelo plano</Badge>
      </div>

      {sorted.length === 0 && <div className="text-sm text-muted-foreground">Sem clientes cadastrados.</div>}

      <div className="space-y-3">
        {sorted.map((v, idx) => (
          <div
            key={v.nome}
            data-testid={`rank-receita-${idx + 1}`}
            className={`rounded-lg border p-4 ${idx === 0 ? "border-primary/40 bg-primary/5" : "border-border bg-background"}`}
          >
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div className="flex items-center gap-3 min-w-0">
                <span className="w-8 h-8 rounded-lg bg-primary/10 text-primary text-sm grid place-items-center font-bold shrink-0">
                  {idx + 1}
                </span>
                <div className="min-w-0">
                  <div className="font-heading font-semibold truncate">{v.nome}</div>
                  <div className="text-xs text-muted-foreground mt-0.5 flex items-center gap-1.5">
                    <TrendingUp className="w-3 h-3" />
                    Ticket médio: <span className="font-mono">{fmtBRL(v.ticket_medio)}</span>
                    <span>· {fmtInt(v.vendas)} vendas</span>
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="font-heading text-xl font-extrabold tabular-nums text-emerald-500">
                  {fmtBRL(v.receita)}
                </div>
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">receita/mês</div>
              </div>
            </div>
            <Progress value={(v.receita / max) * 100} className="h-1.5 mt-3" />
          </div>
        ))}
      </div>
    </div>
  );
}
